<script>
import { defineComponent, h, computed } from 'vue';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import Voice from './channels/Voice.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  instagram: Instagram,
  tiktok: Tiktok,
  voice: Voice,
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    // Computed reativo que re-executa quando registry muda
    const channelComponent = computed(() => {
      console.log('[ChannelFactory] Computing component for:', props.channelName);
      
      // Plugin channels: verificar registry primeiro
      if (typeof window !== 'undefined' && window.chatwoot?.channelRegistry) {
        // Acessar version força reatividade
        const version = window.chatwoot.channelRegistry.version;
        console.log('[ChannelFactory] Registry version:', version);
        
        const channelConfig = window.chatwoot.channelRegistry.getByKey(props.channelName);
        console.log('[ChannelFactory] Registry lookup result:', channelConfig);
        
        if (channelConfig?.component) {
          console.log('[ChannelFactory] Using plugin component for:', props.channelName);
          return channelConfig.component;
        }
      }

      // Fallback: componentes core
      const component = channelViewList[props.channelName];
      console.log('[ChannelFactory] Using core component:', props.channelName, !!component);
      return component;
    });

    return { channelComponent };
  },
  render() {
    return this.channelComponent ? h(this.channelComponent) : null;
  },
});
</script>
